module.exports = __webpack_public_path__ + "img/title4s.718590cb.png";